import type { SearchParams } from '@/server/searchParams.ts';

/**
 * Mirrors `updateUrl`'s set/remove diff applied to a SearchParams object, so the post-update
 * params can be used (e.g. as an API payload) before the URL is actually written. Matches
 * `updateUrl` exactly: each set entry contributes its first key only, then removals are applied
 * (remove wins over set).
 */
export function mergeSearchParams(
  currentParams: SearchParams,
  diff: {
    queryParamsToSet?: { [key: string]: string }[];
    queryParamsToRemove?: string[];
  }
): SearchParams {
  const next: SearchParams = { ...currentParams };
  (diff.queryParamsToSet || []).forEach((kv) => {
    const entries = Object.entries(kv);
    if (entries.length !== 0) {
      const [key, value] = entries[0];
      next[key] = value;
    }
  });
  (diff.queryParamsToRemove || []).forEach((key) => {
    delete next[key];
  });
  return next;
}
